
import UpdatePeriodReviewApp from '../Functionality/UpdatePeriodReviewApp';
import HeadTittle from './../../../../../../../components/HeadTittle';
import ButtonAction from './../../../../../../../components/buttons/ButtonAction';
import {
    EditIcon
} from '../../../../../../../components/buttons/IconButtons';
import RequestedBatchOverviewTable from "../../Request/SubComponents/RequestedBatchOverviewTable";
import React from "react";
import {STATUS_MODEL} from "../../../../../../../enums/statusEnum";
import PeriodReviewDetailsSection from "./PeriodReviewDetailsSection";
import {mapRequestedBatchRows} from "../../Request/Model/Model";
import {permissionObj} from "../../../../../../../Helpers/permission";
import routes from "../../../../../../../Routes/routes";
/**
 *
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend Developer - IBL
 * @Email : sgarcia@ibl.mx
 *
 */
const UpdatePeriodReview = () => {
    const {
        DEV,
        permission,
        isAttendanceSupervisor,
        navigate,
        handleOnBack,
        photoPicker,
        setPhotoPicker,
        handleUpdate,
        emptyFields,
        containerCardRef,
        containerTableRef,
        contentCardRef,
        contentTableRef,
        objectItems,
        periodReviewItem,
        handleChange,
        getAttendancePeriodReview
    } = UpdatePeriodReviewApp();

    if (!DEV &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_MANAGE_ATTENDANCES) &&
        !isAttendanceSupervisor //Used for attendance department supervisor, for can manage attendees, slice loaded in login action
    ) {
        navigate(routes.forbidden);
    }

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={'updates'}>
                <ButtonAction
                    id='btn_upr_update'
                    name='update'
                    Icon={EditIcon}
                    className='btn-icon-edit'
                    onClick={handleUpdate}
                />
            </HeadTittle>
            <div className='row'>
                <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0 pr-sm-0 pr-md-3'
                     ref={containerCardRef}>
                    <div className={"border-full-shades-300 border-radius-8px"} ref={contentCardRef}>
                        <PeriodReviewDetailsSection
                            periodReviewItem={periodReviewItem}
                            emptyFields={emptyFields}
                            handleChange={handleChange}
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                        />
                    </div>
                </div>
                <div className='col-sm-12 col-md-8 col-lg-8 px-0' ref={containerTableRef}>
                    <RequestedBatchOverviewTable
                        contentTableRef={contentTableRef}
                        attendancePeriod={getAttendancePeriodReview}
                        statusId={ STATUS_MODEL.PENDING }
                        objectItems={mapRequestedBatchRows(objectItems) || []}
                    />
                </div>
            </div>
        </>
    );
};

export default UpdatePeriodReview;
